import type { ReactNode } from 'react'

type ComparisonHeaderProps = {
  readonly caption: string
  readonly rowLabels: ReadonlyArray<string>
}

const ComparisonHeader = ({ caption, rowLabels }: ComparisonHeaderProps) => {
  return (
    <tr className="border-b border-0 border-solid border-neutral-medium last:border-b-0 grid grid-cols-subgrid col-span-full">
      <td
        id="comparison-table-caption"
        className="font-bold text-sm md:text-lg pt-0 pb-2 md:pb-6 px-0.5 first:pl-0 last:pr-0 flex items-center"
      >
        {caption}
      </td>
      {rowLabels.map(label => (
        <th
          key={label}
          scope="col"
          className="border-r last:border-r-0 border-0 border-solid border-neutral-medium font-normal text-xs md:text-lg pt-0 pb-2 md:pb-6 px-0.5 first:pl-0 last:pr-0 flex items-center justify-center"
        >
          {label}
        </th>
      ))}
    </tr>
  )
}
export function ComparisonTableV2({
  caption,
  rowLabels,
  children
}: {
  readonly caption: string
  readonly rowLabels: readonly string[]
  readonly children: ReactNode
}) {
  return (
    <table
      aria-labelledby="comparison-table-caption"
      className="box-border rounded-2xl bg-neutral-100 py-6 px-2 md:p-9 mb-4 md:mb-6 last:mb-0 w-full"
      data-testid="ComparisonTableV2"
    >
      <tbody
        className="grid"
        style={{
          gridTemplateColumns: `minmax(0,2fr) ${'minmax(0,1fr) '.repeat(rowLabels.length).trim()}`
        }}
      >
        <ComparisonHeader caption={caption} rowLabels={rowLabels} />
        {children}
      </tbody>
    </table>
  )
}
